var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLabelsActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.75 15.75H24L33 24.75L24.75 33L15.75 24V15.75Z",
    stroke: "#CC0000",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.25 21.75C21.0784 21.75 21.75 21.0784 21.75 20.25C21.75 19.4216 21.0784 18.75 20.25 18.75C19.4216 18.75 18.75 19.4216 18.75 20.25C18.75 21.0784 19.4216 21.75 20.25 21.75Z",
    fill: "#CC0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLabelsActive);
export default __webpack_public_path__ + "static/media/labels-active.fe21a08212fb20f0c262a2d19f01a80c.svg";
export { ForwardRef as ReactComponent };